import { createAction } from "@reduxjs/toolkit";

const wsEvent = createAction("ws/event");
const wsConnect = createAction("ws/connect");

export { wsEvent, wsConnect };
